import React, { useMemo } from 'react';
import logo from '../../assets/logo.svg';
import logoChristmas from '../../assets/logo-christmas.svg';
import { externalRoutes } from '../../features/routes';

export default function Header() {
  const isDecember = useMemo(() => {
    const date = new Date();
    const month = date.getMonth();

    return month === 11;
  }, []);

  return (
    <header className="header">
      <div className="logo-wrapper">
        <a href={externalRoutes.giftFlom}>
          {isDecember ? (
            <img style={{ width: 151 }} src={logoChristmas} className="logo" alt="logo" />
          ) : (
            <img src={logo} className="logo" alt="logo" />
          )}
        </a>
      </div>
      <div className="menu-wrapper">
        <a href="mailto:support@flom.co">Support</a>
      </div>
    </header>
  );
}
